import client from '@/http'

const loadAll = (context, params) => {
  client.get(
    `tables/${params.tableId}/reports`
  ).then(
    (res) => {
      context.commit('SET_REPORTS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, params) => {
  client.get(
    `reports/${params.reportId}`
  ).then(
    (res) => {
      context.commit('SET_REPORT', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadWithAccessCode = (context, params) => {
  client.post(
    `reports/view`, {
      accessCode: params.accessCode
    }
  ).then(
    (res) => {
      context.commit('SET_REPORT', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadForAdmin = (context, params) => {
  client.get(
    `reports/${params.id}`
  ).then(
    (res) => {
      context.commit('SET_REPORT', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const getColumnTypes = (context, columns) => {
  client.post(
    `columns/types`, {
      columns: columns
    }
  ).then(
    (res) => {
      context.commit('PATCH_COLUMNS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `/reports/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )

    if (params.is_accessible && !params.access_code) {
      context.dispatch('generateAccessCode', params.id)
    }
  } else {
    client.post(
      '/reports', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, reportId) => {
  client.delete(
    `/reports/${reportId}`
  ).then(
    () => {
      context.commit('REMOVE', reportId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  save,
  remove,
  load,
  loadAll,
  loadForAdmin,
  loadWithAccessCode,
  getColumnTypes
}
